import { ThreeEvent } from '@react-three/fiber'
import { formatForLabel } from 'features/siteMap/communalMapStyling/FormatForLabel'
import { useTilesetMapFeatureHelpers } from 'features/siteMap/tilesetMap/features/useTilesetMapFeatureHelpers'
import { TilesetMapFeatureLabel } from 'features/siteMap/tilesetMap/objects/TilesetMapFeatureLabel'
import { FC, ReactNode, useMemo, useState } from 'react'
import { SiteFeaturePin } from 'types'

import { PinMesh } from './PinMesh'

interface GeographicPinProps {
  pin: SiteFeaturePin
  onClick: (e: ThreeEvent<MouseEvent>) => ReactNode
  image?: ReactNode
}

export const GeographicPinFeature: FC<GeographicPinProps> = ({
  pin,
  onClick,
  image,
}) => {
  const { convertCartographicToPosition } = useTilesetMapFeatureHelpers()

  const [hovered, setHovered] = useState(false)

  const xyz = useMemo(
    () =>
      convertCartographicToPosition({
        lat: pin.coordinate.lat,
        lon: pin.coordinate.lon,
        height: pin.coordinate.height,
      }),
    [convertCartographicToPosition, pin.coordinate]
  )

  const visible = true

  return (
    <group position={xyz} visible={visible}>
      <PinMesh
        name={pin.id}
        color={pin.color}
        radius={pin.geometry.radius}
        userData={{ siteFeature: pin, uid: pin.id }}
        hovered={hovered}
        onPointerMove={(e) => {
          if (
            e.intersections.length > 0 &&
            e.object === e.intersections[0].object
          ) {
            setHovered(true)
            e.stopPropagation()
          } else {
            setHovered(false)
          }
        }}
        onPointerLeave={() => setHovered(false)}
        onClick={(e) => {
          onClick(e)
          e.stopPropagation()
        }}
      />
      {!pin.name ? null : (
        <group position={[0, image ? 200 : 0, 0]}>
          <TilesetMapFeatureLabel
            body={formatForLabel(pin.name, image ?? null)}
            hovered={hovered}
            visible={visible}
          />
        </group>
      )}
    </group>
  )
}
